<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2 class="fm_head" id="_idParaDest-2"><a href="#/text/9780062970596_Contents#r_idParaDest-2"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">Epigraph</span></a></h2>
<p class="epig"><span class="hide">           </span>Like the touch of rain she was</p>
<p class="epig"><span class="hide">           </span>On a man’s flesh and hair and eyes</p>
<p class="epig"><span class="hide">           </span>When the joy of walking thus</p>
<p class="epig"><span class="hide">           </span>Has taken him by surprise.</p>
<p class="orn1"><span class="hide">                   </span>“Like the Touch of Rain,” Edward Thomas</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062970596_Epigraph.vue?4b3a974b